/* eslint-disable */
import { useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import { getPositions, getPositionStatistics } from '@/store/position/actions';

import { selectPositions } from '@/store/position/selectors';

import { Col, Row, Table, Tooltip } from 'antd';
import { HiOutlineBadgeCheck, HiOutlineClipboardCheck, HiOutlineClock } from 'react-icons/hi';

import { createSelector } from '@reduxjs/toolkit';
import PropTypes from 'prop-types';

import css2 from '../index.module.scss';
import css from './Views.module.scss';

export const ViewPosition = props => {
  const [filterPosition, setFilterPosition] = useState([]);

  useEffect(() => {
    props.getPositionStatistics();
    props.getPositions({ size: 1000 });
  }, []);

  useEffect(() => {
    if (props.allPositions && Array.isArray(props.allPositions.content)) {
      setFilterPosition(
        props.allPositions.content.map(item => {
          const resultPositions = {};
          resultPositions.text = item.name;
          resultPositions.value = item.name;
          return resultPositions;
        })
      );
    }
  }, [props.allPositions]);

  const getColumns = () => {
    const { t, hasPosition, hasCoins, txtPosition } = props;
    let columns = [];

    if (hasPosition === true) {
      columns.push({
        title: txtPosition,
        dataIndex: 'position',
        key: 'position',
        filters: filterPosition,
        filterMultiple: false,
        filterSearch: true,
      });
    }

    columns.push({
      title: t('users'),
      dataIndex: 'numberOfEmployees',
      key: 'numberOfEmployees',
      align: 'center',
      defaultSortOrder: 'descend',
      sorter: true,
    });

    if (hasCoins) {
      columns.push({
        title: t('score'),
        dataIndex: 'coins',
        key: 'coins',
        align: 'center',
        defaultSortOrder: 'descend',
        sorter: true,
      });
    }

    columns.push({
      title: t('statistics'),
      dataIndex: 'statistics',
      key: 'statistics',
      width: 180,
    });

    return columns;
  };

  const getData = () => {
    const { t, positions } = props;
    if (positions && Array.isArray(positions)) {
      return positions.map((item, index) => {
        if (item.name === null) {
          item.name = t('noData');
        }

        return {
          position: item.name,
          numberOfEmployees: item.numberOfEmployees,
          coins: item.coins,
          statistics: (
            <div className={css2['userStatistics']}>
              <Tooltip placement='top' title={t('finished')}>
                <div className={css2['iconGreen']}>
                  <HiOutlineBadgeCheck />
                  &nbsp;{item.finished}
                </div>
              </Tooltip>

              <Tooltip placement='top' title={t('planned')}>
                <div className={css2['iconBlue']}>
                  <HiOutlineClock />
                  &nbsp;{item.planned}
                </div>
              </Tooltip>

              <Tooltip placement='top' title={t('created')}>
                <div className={css2['iconRed']}>
                  <HiOutlineClipboardCheck />
                  &nbsp;{item.created}
                </div>
              </Tooltip>
            </div>
          ),
          key: index,
        };
      });
    }
  };

  const onChangeTable = (pagination, filters, sorter) => {
    props.getPositionStatistics({
      page: pagination.current - 1 || 0,
      name: filters.hasOwnProperty('position') ? filters.position?.[0] : '',
      sort: sorter.columnKey ? `${sorter.columnKey},${sorter.order == 'ascend' ? 'desc' : 'asc'}` : '',
    });
  };

  const pagination =
    props.positionsTotal > props.positionsPageSize
      ? {
          current: props.positionsPageNumber + 1,
          total: props.positionsTotal,
          pageSize: props.positionsPageSize,
          showSizeChanger: false,
          responsive: true,
          hideOnSinglePage: true,
        }
      : false;

  const render = () => {
    return (
      <Row className={css['Views-tableWrapper']}>
        <Col span={24} style={{ padding: '1rem' }}>
          <Table
            // className={css['Views-table']}
            columns={getColumns()}
            dataSource={getData()}
            loading={props.isLoading}
            bordered={true}
            pagination={pagination}
            onChange={onChangeTable}
            scroll={{ x: true }}
          />
        </Col>
      </Row>
    );
  };
  return render();
};

ViewPosition.propTypes = {
  t: PropTypes.func,
  hasPosition: PropTypes.bool,
  isLoading: PropTypes.bool,
  getPositionStatistics: PropTypes.func,
  positions: PropTypes.array,
  txtPosition: PropTypes.string,
};

const mapStateToProps = createSelector([selectPositions], selectPositions => ({
  positions: selectPositions.positionStatistics,
  positionsTotal: selectPositions.positionStatisticsTotal,
  positionsPageSize: selectPositions.positionStatisticsPageSize,
  positionsPageNumber: selectPositions.positionStatisticsPageNumber,
  allPositions: selectPositions.positions,
}));

const mapActionsToProps = {
  getPositionStatistics,
  getPositions,
};

export default connect(mapStateToProps, mapActionsToProps)(withTranslation('colleague')(ViewPosition));
